let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) subscribers[eventName] = [];
  subscribers[eventName] = [...subscribers[eventName], callback];
  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function isIE() {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE ');
  const trident = ua.indexOf('Trident/');
  return (msie > 0 || trident > 0);
}

function publish(eventName, data) {
  if (subscribers[eventName]) subscribers[eventName].forEach((callback) => callback(data));
}

function createObserver(options) {
  const threshold = options.threshold ? options.threshold : 0;
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (typeof options.callback === 'function') {
          options.callback();
          observer.unobserve(entry.target);
        }
      }
    });
  }, {rootMargin: `0px 0px ${threshold}px 0px`});
  observer.observe(options.element);
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  const expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

function getCookie(cname) {
  const name = cname + '=';
  const ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }

  return '';
}

function deleteCookie(name) {
  document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function convertBreakpoint(breakpoint) {
  let screen;
  switch (breakpoint) {
    case 'small':
      screen = '(max-width: 749px)';
      break;
    case 'medium':
      screen = '(min-width: 750px) and (max-width: 989px)';
      break;
    case 'large-up':
      screen = '(min-width: 990px)';
      break;
  }

  return screen
}

function setScrollbarWidth() {
  const scrollbarWidth = window.innerWidth - document.body.clientWidth;
  if (scrollbarWidth > 0) document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
}

function getFocusableElements(container) {
  return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}

function closeSideDrawer() {
	const sideDrawers = document.querySelectorAll('side-drawer, cart-drawer, pickup-availability-drawer');
  [...sideDrawers].forEach(drawer => drawer.close());
}

function hideModalDialog() {
	const modalDialogs = document.querySelectorAll('modal-dialog, quick-add-modal');
  [...modalDialogs].forEach(modal => modal.hide());
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
  if (summary.nextElementSibling.getAttribute('id')) summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  summary.addEventListener('click', (event) => event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open')));
  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;
    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);
  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' && ['search', 'text', 'email', 'url'].includes(elementToFocus.type) && elementToFocus.value) elementToFocus.setSelectionRange(0, elementToFocus.value.length);
}
// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) mouseClick = false;
  });

  window.addEventListener('mousedown', (event) => mouseClick = true);

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
    if (mouseClick) return;
    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');
  }, true );
}

function visibleMedia(media) {
  return Array.from(media).find((item) => {
    const style = window.getComputedStyle(item);
    return style.display !== 'none';
  });
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*'));
  document.querySelectorAll('.js-vimeo').forEach((video) => video.contentWindow.postMessage('{"method":"pause"}', '*'));
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);
  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;
  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) return;
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};
  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') cents = cents.replace('.','');
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || window.shopMoney.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) return 0;
    number = number.toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));
  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }
      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class CardHoverDistance extends HTMLElement {
  constructor() {
    super();
    this.resizeObserver = new ResizeObserver(() => this.update());
  }

  get breakpoint() {
    return this.dataset.breakpoint || null
  }

  get parent() {
    return this.closest(this.dataset.parent)
  }

  connectedCallback() {
    this.init();
    this.resizeObserver.observe(document.body);
  }

  disconnectedCallback() {
    this.resizeObserver.disconnect();
  }

  init() {
    if (!this.parent || !this.breakpoint) return;
    this.update();
    this.resizeObserver.observe(document.body);
  }

  update() {
    if (!this.parent) return;
    const matches = window.matchMedia(convertBreakpoint(this.breakpoint)).matches;
    if (matches) {
      this.parent.style.setProperty('--card-hover-distance', `${this.offsetHeight}px`);
    } else {
      this.parent.style.removeProperty('--card-hover-distance');
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      this.init();
    }
  }
}

customElements.define('card-hover-distance', CardHoverDistance);

class CollapsibleContent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    createObserver({
      element: this,
      callback: this.init.bind(this),
      threshold: 400
    });
  }

  get breakpoint() {
    return this.dataset.breakpoint
  }

  get details() {
    return this.querySelector('details')
  }

  get summary() {
    return this.querySelector('summary')
  }

  init() {
    this.details.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summary.addEventListener('click', this.toggle.bind(this));
    this.checkBreakpoint();
    window.addEventListener('resize', this.checkBreakpoint.bind(this));
  }

  checkBreakpoint() {
    if(this.breakpoint == 'all' || this.breakpoint == undefined) return;
    if (!window.matchMedia(convertBreakpoint(this.breakpoint)).matches) {
      this.details.setAttribute('open', true);
    } else if (this.dataset.open == undefined){
      this.details.removeAttribute('open');
    }
  }

  toggle(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open();
  }

  open() {
    this.details.setAttribute('open', true);
  }

  close() {
    this.details.removeAttribute('open');
  }
}

customElements.define('collapsible-content', CollapsibleContent);

class ColorSwatch extends HTMLElement {
  constructor() {
    super();

    this.swatches = this.querySelectorAll('[data-variant-image-src]');
    [...this.swatches].forEach((swatch) => swatch.addEventListener('click', this.swapImage.bind(this)));
  }

  swapImage(event) {
    event.preventDefault();
    const mediaFeatured = event.currentTarget.closest('.card').querySelectorAll('img');
    if (!mediaFeatured.length) return;
    [...mediaFeatured].forEach((media) => {
      media.setAttribute('src', event.currentTarget.dataset.variantImageSrc);
      media.setAttribute('srcset', event.currentTarget.dataset.variantImageSrcset);
    });
    [...this.swatches].forEach((swatch) => swatch.classList.toggle('active', swatch.contains(event.target)));
  }
}

customElements.define('color-swatch', ColorSwatch);

class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.date = new Date(`${this.dataset.month}/${this.dataset.day}/${this.dataset.year} ${this.dataset.hour}:${this.dataset.minute}:00`);
    this.unit = this.dataset.dateTimeUnit;
    this.parent = this.dataset.parent;
    this.template = this.querySelector('template').content.firstElementChild.innerHTML;
  }

  connectedCallback() {
    createObserver({
      element: this,
      callback: this.init.bind(this),
      threshold: 200
    });
  }

  init() {
    this.calculate();
    this.timerInterval = setInterval(this.calculate.bind(this), 1000);
  }

  calculate() {
    const now = new Date(),
      countTo = new Date(this.date),
      timeDifference = (countTo - now);

    if (timeDifference < 0) {
      this.complete();
      return;
    }

    let content = this.template;

    const secondsInADay = 60 * 60 * 1000 * 24,
      secondsInAHour = 60 * 60 * 1000;
    const days = Math.floor(timeDifference / (secondsInADay) * 1);
    const hours = Math.floor((timeDifference % (secondsInADay)) / (secondsInAHour) * 1);
    const mins = Math.floor(((timeDifference % (secondsInADay)) % (secondsInAHour)) / (60 * 1000) * 1);
    const secs = Math.floor((((timeDifference % (secondsInADay)) % (secondsInAHour)) % (60 * 1000)) / 1000 * 1);
    let day_text, hour_text, min_text, sec_text;

    if(this.unit == 'short') {
      day_text = this.dataset.dayText;
      hour_text = this.dataset.hourText;
      min_text = this.dataset.minuteText;
      sec_text = this.dataset.secondText;
    } else {
      day_text = days === 1 ? this.dataset.dayText : this.dataset.daysText;
      hour_text = hours === 1 ? this.dataset.hourText : this.dataset.hoursText;
      min_text = mins === 1 ? this.dataset.minuteText : this.dataset.minutesText;
      sec_text = secs === 1 ? this.dataset.secondText : this.dataset.secondsText;
    }

    content = content.replaceAll('[days]', this.addLeadingZero(days));
    content = content.replaceAll('[hours]', this.addLeadingZero(hours));
    content = content.replaceAll('[mins]', this.addLeadingZero(mins));
    content = content.replaceAll('[secs]', this.addLeadingZero(secs));
    content = content.replaceAll('[days_text]', day_text);
    content = content.replaceAll('[hours_text]', hour_text);
    content = content.replaceAll('[mins_text]', min_text);
    content = content.replaceAll('[secs_text]', sec_text);

    const html = new DOMParser().parseFromString(content, 'text/html');
    this.innerHTML = html.body.innerHTML;
  }

  addLeadingZero(num) {
    return num < 10 ? `0${num}` : `${num}`;
  }

  complete() {
    if (this.timerInterval) clearInterval(this.timerInterval);
    if(this.parent != undefined) document.querySelector(this.parent)?.remove();
  }
}

customElements.define('countdown-timer', CountdownTimer);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    if (this.posterElement) this.posterElement.addEventListener('click', this.onPosterClick.bind(this));
  }
  
  connectedCallback() {
    createObserver({
      element: this,
      callback: this.init.bind(this),
      threshold: 0
    });
  }

  get autoplay() {
    return this.hasAttribute('autoplay');
  }

  get playing() {
    return this.hasAttribute('playing');
  }

  get posterElement() {
    return this.querySelector('[id^="Deferred-Poster-"]');
  }

  get controlledElement() {
    return this.hasAttribute('aria-controls') ? document.getElementById(this.getAttribute('aria-controls')) : null;
  }

  get player() {
    return this.playerProxy = this.playerProxy || new Proxy(this.playerTarget(), {
      get: (target, prop) => {
        return async () => {
          target = await target;
          this.playerHandler(target, prop);
        };
      }
    });
  }

  static get observedAttributes() {
    return ['playing'];
  }

  init() {
    if (this.autoplay) if (!this.paused) this.play();
  }

  onPosterClick(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.playing) {
      this.paused = true;
      this.pause();
      // event.currentTarget.setAttribute('aria-hidden', false);
    } else {
      this.paused = false;
      this.play();
      // event.currentTarget.setAttribute('aria-hidden', true);
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'playing') {
      if (oldValue === null && newValue === '') {
        this.dispatchEvent(new CustomEvent('video:play', { bubbles: true }));
      } else if (newValue === null) {
        this.dispatchEvent(new CustomEvent('video:pause', { bubbles: true }));
      }
    }
  }

  play() {
    if (!this.playing) this.player.play();
  }

  pause() {
    if (this.playing) this.player.pause();
  }
}

class VideoMedia extends DeferredMedia {
  constructor() {
    super();
  }

  playerTarget() {
    if (this.hasAttribute('host')) {
      this.setAttribute('loaded', '');
      this.classList.remove('loading');
      return new Promise(async (resolve) => {
        const templateElement = this.querySelector('template');
        if (templateElement) templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
        const muteVideo = this.hasAttribute('autoplay') || window.matchMedia('screen and (max-width: 1023px)').matches;
        const script = document.createElement('script');
        script.type = 'text/javascript';
        if (this.getAttribute('host') === 'youtube') {
          if (!window.YT || !window.YT.Player) {
            script.src = 'https://www.youtube.com/iframe_api';
            document.head.appendChild(script);
            await new Promise((resolve2) => script.onload = resolve2);
          }
          await onYouTubePromise;
          const player = new YT.Player(this.querySelector('iframe'), {
            events: {
              onReady: () => {
                if (muteVideo) player.mute();
                resolve(player);
              },
              onStateChange: (event) => {
                if (event.data === YT.PlayerState.PLAYING) {
                  this.setAttribute('playing', '');
                } else if (event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.PAUSED) {
                  this.removeAttribute('playing');
                }
              }
            }
          });
        }
        if (this.getAttribute('host') === 'vimeo') {
          if (!window.Vimeo || !window.Vimeo.Player) {
            script.src = 'https://player.vimeo.com/api/player.js';
            document.head.appendChild(script);
            await new Promise((resolve2) => script.onload = resolve2);
          }
          const player = new Vimeo.Player(this.querySelector('iframe'));
          if (muteVideo) player.setMuted(true);
          player.on('play', () => this.setAttribute('playing', ''));
          player.on('pause', () => this.removeAttribute('playing'));
          player.on('ended', () => this.removeAttribute('playing'));
          resolve(player);
        }
      });
    } else {
      this.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', '');
      this.classList.remove('loading');
      const player = this.querySelector('video');
      player.addEventListener('play', () => {
        this.setAttribute('playing', '');
        this.removeAttribute('suspended');
      });
      player.addEventListener('pause', () => {
        if (!player.seeking && player.paused) this.removeAttribute('playing');
      });
      return player;
    }
  }

  playerHandler(target, prop) {
    if (this.getAttribute('host') === 'youtube') {
      prop === 'play' ? target.playVideo() : target.pauseVideo();
    } else {
      if (prop === 'play' && !this.hasAttribute('host')) {
        target.play().catch((error) => {
          if (error.name === 'NotAllowedError') {
            this.setAttribute('suspended', '');
            target.controls = true;
          }
        });
      } else {
        target[prop]();
      }
    }
  }
}

customElements.define('video-media', VideoMedia);

class ImageAnimation extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    createObserver({
      element: this,
      callback: this.init.bind(this),
      threshold: 0
    });
  }

  init() {
    this.setAttribute('loaded', true);
  }
}

customElements.define('image-animation', ImageAnimation);

class ImageZoom extends HTMLElement {
  constructor() {
    super();
    
    this.image = this.querySelector('img');
    this.addEventListener('mousemove', this.onZoom.bind(this));
    this.addEventListener('mouseover', this.onZoom.bind(this));
    this.addEventListener('mouseleave', this.offZoom.bind(this));
  }

  onZoom(event) {
    const x = event.clientX - event.target.offsetLeft;
    const y = event.clientY - event.target.offsetTop;
    this.image.style.transformOrigin = `${x}px ${y}px`;
    this.image.style.transform = "scale(2)";
  }

  offZoom() {
    this.image.style.transformOrigin = `center center`;
    this.image.style.transform = "scale(1)";
  }
}

customElements.define('image-zoom', ImageZoom);

class FocalPoint extends HTMLElement {
  constructor() {
    super();
    if(!this.button) return;
    this.button.addEventListener('click', this.onClickButton.bind(this));
  }

  get button() {
    return this.querySelector('button')
  }

  get popup() {
    return document.querySelector(this.dataset.popup)
  }

  onClickButton(event) {
    if(!this.popup) return;
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.popup.show();
    document.body.addEventListener('click', this.onBodyClickEvent);
  }

  onBodyClick(event) {
    if(!this.popup) return;
    if (!this.button.contains(event.target) && !this.popup.contains(event.target)) {
      this.popup.hide();
      document.body.removeEventListener('click', this.onBodyClickEvent);
    }
  }
}

customElements.define('focal-point', FocalPoint);

class FocalPopup extends HTMLElement {
  constructor() {
    super();
    const resizeObserver = new ResizeObserver(() => this.setPosition());
    resizeObserver.observe(document.body);
    document.body.addEventListener('click', this.onBodyEvent.bind(this));
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.container.appendChild(this);
    this.load();
  }

  get point() {
    return document.querySelector(this.dataset.point)
  }

  get container() {
    return this.closest('[data-focal-container]')
  }

  load() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      this.appendChild(content.firstElementChild);
      this.setAttribute('loaded', true);
    }
  }

  show(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    this.setAttribute('open', '');
    this.setPosition();
  }

  hide() {
    this.removeAttribute('open');
  }

  setPosition() {
    if(this.hasAttribute('open')) {
      let positionTop = this.point.getBoundingClientRect().top - this.container.getBoundingClientRect().top;
      let positionLeft = this.point.getBoundingClientRect().left - this.container.getBoundingClientRect().left;
      this.style.setProperty(`--top`, `${positionTop}px`);
      this.style.setProperty(`--left`, `${positionLeft}px`);
      // let checkTop = positionTop + this.offsetHeight + this.point.offsetHeight/2 + 8 > this.container.offsetHeight;
      let checkLeft = positionLeft + this.offsetWidth + this.point.offsetWidth/2 + 8 > this.container.offsetWidth;
      this.classList.toggle('position-right', checkLeft);
      // this.classList.toggle('position-bottom', checkTop);
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  onBodyEvent(event){
    if ((!this.contains(event.target)) && (!this.point.contains(event.target))) this.hide();
  }
}

customElements.define('focal-popup', FocalPopup);

class LoadingOverlay extends HTMLElement {
  constructor() {
    super();
  }

  enableLoading() {
    this.classList.remove('hidden');
    this.querySelector('[aria-hidden]')?.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    this.classList.add('hidden');
    this.querySelector('[aria-hidden]')?.setAttribute('aria-hidden', true);
  }
}

customElements.define('loading-overlay', LoadingOverlay);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.delay = 0;
    this.animate = false;
    this.bindEvents();
  }

  get button() {
    return this.querySelector('[id^="ModalClose-"]');
  }

  get overlay() {
    return this.querySelector('[id^="Modal-Overlay-"]');
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.elements = Array.from(document.body.children).filter(element => element.id == this.getAttribute('id'));
    this.elements.length > 0 ? this.remove() : document.body.appendChild(this);
  }

  bindEvents() {
    this.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.hide());
    this.overlay?.addEventListener('click', this.hide.bind(this));
    this.button?.addEventListener('click', this.hide.bind(this, false));
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      const template = this.querySelector('.template-popup');
      if(!template) return;
      content.appendChild(template.content.firstElementChild.cloneNode(true));
      template.parentNode.appendChild(content.firstElementChild);
      this.setAttribute('loaded', true);
    }
  }

  show(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const templatePopup = this.querySelector('.template-popup');
    if (templatePopup) this.loadContent();
    setTimeout(() => {
      this.setAttribute('open', '');
      this.classList.add('animate', 'active');
      this.querySelector('.modal__content').scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      setScrollbarWidth();
      document.body.classList.add('modal-show', 'overflow-hidden');
    }, this.delay);
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    this.removeAttribute('open');
    this.classList.remove('animate', 'active');
    document.body.classList.remove('modal-show', 'overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    removeTrapFocus(this.activeElement);
    window.pauseAllMedia();
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class MoreLessLayout extends HTMLElement {
  constructor() {
    super();
    this.content = this.querySelector('.more-less-layout__content');
    this.button = this.querySelector('button');
    this.readMoreText = this.getAttribute('data-read-more-text') || 'Read More';
    this.readLessText = this.getAttribute('data-read-less-text') || 'Read Less';
    this.maxLinesDesktop = parseInt(this.getAttribute('data-max-lines-desktop'), 10) || 3;
    this.maxLinesMobile = parseInt(this.getAttribute('data-max-lines-mobile'), 10) || 2;
    this.expanded = false;
    this.updateStyles();
    this.checkButtonVisibility();
    this.button.addEventListener('click', () => this.toggleReadMore());
  }

  updateStyles() {
    this.content.style.display = '-webkit-box';
    this.content.style.overflow = 'hidden';
    this.content.style.webkitBoxOrient = 'vertical';
    this.content.style.webkitLineClamp = this.getMaxLines();
  }

  getMaxLines() {
    return window.matchMedia('(min-width: 990px)').matches ? this.maxLinesDesktop : this.maxLinesMobile
  }

  toggleReadMore() {
    if (this.expanded) {
      this.content.style.webkitLineClamp = this.getMaxLines();
      this.button.querySelector('span').textContent = this.readMoreText;
    } else {
      this.content.style.webkitLineClamp = "unset";
      this.button.querySelector('span').textContent = this.readLessText;
    }
    this.classList.toggle('expanded', !this.expanded);
    this.expanded = !this.expanded;
  }

  checkButtonVisibility() {
    const fullLines = this.getFullLineCount();
    const maxLines = this.getMaxLines();
    this.button.closest('.more-less-layout__button').classList.toggle('hidden', fullLines <= maxLines);
  }

  getFullLineCount() {
    const style = window.getComputedStyle(this.content);
    const lineHeight = parseFloat(style.lineHeight);
    const fullHeight = this.content.scrollHeight;
    return Math.round(fullHeight / lineHeight);
  }

  connectedCallback() {
    window.addEventListener('resize', () => {
      if (!this.expanded) {
        this.updateStyles();
        this.checkButtonVisibility();
      }
    });
  }
}

customElements.define('more-less-layout', MoreLessLayout);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);
  
class SideDrawer extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
  }

  get overlay() {
    return this.querySelector('[id^="Drawer-Overlay-"]');
  }

  connectedCallback() {
    this.bindEvents();
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  bindEvents() {
    this.overlay.addEventListener('click', this.close.bind(this));
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    if (this.activeElement) this.activeElement.setAttribute('open', '');
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});
    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this;
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
      setScrollbarWidth();
    }, { once: true });
    this.isOpen = true;
    document.body.classList.add('drawer-show');
  }

  close() {
    this.classList.remove('animate', 'active');
    if (this.activeElement) this.activeElement.removeAttribute('open');
    removeTrapFocus(this.activeElement);
    this.isOpen = false;
    document.body.classList.remove('drawer-show');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('side-drawer', SideDrawer);

class SideDrawerOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick(event) {
    let _target = event.currentTarget;
    const drawer = document.querySelector(this.getAttribute('data-side-drawer'));
    drawer && (_target.hasAttribute('open') ? drawer.close() : drawer.open(_target));
  }
}

customElements.define('side-drawer-opener', SideDrawerOpener);

class ThemeSwiper extends HTMLElement {
  constructor() {
    super();
    this.disable = false;
    this.slider = this.querySelector('.swiper');
    this.pagination = this.querySelector('.swiper-pagination');
    this.scrollbar = this.querySelector('.swiper-scrollbar');
    this.prev = this.querySelector('.swiper-button-prev');
    this.next = this.querySelector('.swiper-button-next');
    this.play = this.querySelector('.swiper-button-play');
    this.pause = this.querySelector('.swiper-button-pause');
    this.count = this.querySelector('[data-swiper-count]');
    this.breakpointList = ['small', 'medium', 'large-up'];
    this.defaultSettings = this.dataset.swiper || {};
    if (Object.keys(this.defaultSettings).length != 0) this.defaultOptions = JSON.parse(this.defaultSettings);
    this.options = Object.assign({}, this.defaultOptions);
    this.options = {
      ...this.options,
      pagination: {
        el: this.pagination,
        clickable: true,
        renderBullet: (index, className) => {
          return `<span class="${className}">${index + 1}</span>`;
        }
      },
      navigation: {
        prevEl: this.prev,
        nextEl: this.next
      },
      scrollbar: {
        el: this.scrollbar,
        hide: false
      },
      a11y: {
        enabled: true
      },
      on: {
        init: (element) => {
          const selectedElement = element.slides[element.activeIndex];
          if (!selectedElement) return;
          if (selectedElement.dataset.type === 'video') {
            const videoElement = window.visibleMedia(selectedElement.querySelectorAll('video-media'));
            videoElement?.play();
          }
          this.checkNavigation(element);
          this.checkPagination(element);
          element.slides.forEach((slide, index) => slide.setAttribute('data-index', index));
        }
      }
    }
  }

  get autoplayDelayTime() {
    return parseInt(this.getAttribute('data-autoplay-delay'))
  }

  get items() {
    return this._items = this._items || Array.from(this.querySelectorAll('.swiper-slide'));
  }

  connectedCallback() {
    if (!this.getAttribute('loaded')) {
      createObserver({
        element: this,
        callback: this.init.bind(this),
        threshold: -200
      });
    } else {
      this.init();
    }
  }

  init() {
    if (!this.disable) {
      this.disable = true;
      this.swiper = new Swiper(this.slider, this.options);
      this.swiper.on('resize', () => {
        // code here
        this.checkNavigation(this.swiper);
        this.checkPagination(this.swiper);
      });

      this.swiper.on('update', () => {
        this.checkNavigation(this.swiper);
        this.checkPagination(this.swiper);
      });

      this.swiper.on('transitionStart', () => {
        const oldElement = this.swiper.slides[this.swiper.previousIndex];
        if (oldElement && oldElement.dataset.type === 'video') {
          const videoElement = window.visibleMedia(oldElement.querySelectorAll('video-media'));
          videoElement?.pause();
        }
      });

      this.swiper.on('transitionEnd', () => {
        const newElement = this.swiper.slides[this.swiper.activeIndex];
        if (newElement && newElement.dataset.type === 'video') {
          const videoElement = window.visibleMedia(newElement.querySelectorAll('video-media'));
          videoElement?.play();
        }
      });

      this.swiper.on('slideChange', () => {
        this.swiper.pagination.render();
        this.swiper.pagination.update();
        this.swiper.navigation.destroy();
        this.swiper.navigation.init();
        this.dispatchEvent(new CustomEvent('slider:change', { bubbles: true, detail: { currentPage: this.swiper.activeIndex } }));
      });

      this.swiper.on('slideChangeTransitionStart', () => {
        this.count && this.setActiveSlideItemIndex();
      });

      this.swiper.on('slideChangeTransitionEnd', () => {
        // code here
      });

      this.play?.addEventListener('click', this.playSlider.bind(this));
      this.pause?.addEventListener('click', this.pauseSlider.bind(this));

      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => this.setActiveSlideItem(this.items.indexOf(event.target)));
      }
    } else if(this.disable) {
      if(this.swiper) {
        this.swiper.destroy();
        this.disable = false;
      }
    }
  }

  setActiveSlideItem(activeIndex) {
    this.swiper && this.swiper.slideTo(activeIndex);
  }

  setActiveSlideItemIndex() {
    this.count.innerHTML = this.swiper.activeIndex < 9 ? `0${this.swiper.activeIndex + 1}` : this.swiper.activeIndex + 1;
  }

  unSlider(swiper) {
    if(swiper) {
      swiper.destroy();
      this.disable = false;
    }
  }

  playSlider() {
    this.play?.classList.add('hidden');
    this.pause?.classList.remove('hidden');
    this.swiper.params.autoplay.delay = this.autoplayDelayTime;
    this.swiper.autoplay.start();
    this.classList.remove('theme-swiper--paused');
  }

  pauseSlider() {
    this.pause?.classList.add('hidden');
    this.play?.classList.remove('hidden');
    this.swiper.params.autoplay.delay = 0;
    this.swiper.autoplay.stop();
    this.classList.add('theme-swiper--paused');
  }

  checkPagination(swiper) {
    let pagination = swiper.pagination;
    if(!pagination.el || pagination.bullets.length == 1) return;
    let breakpoint = [...this.breakpointList].find((breakpoint) => window.matchMedia(convertBreakpoint(breakpoint)).matches);
    this.classList.toggle('has-pagination', !pagination.el.classList.contains(`${breakpoint}-hide`));
  }

  checkNavigation(swiper) {
    let navigation = swiper.navigation;
    if (!navigation?.nextEl && !navigation?.prevEl) return;
    const nextDisabled = navigation.nextEl?.hasAttribute('disabled');
    const prevDisabled = navigation.prevEl?.hasAttribute('disabled');
    if (nextDisabled && prevDisabled) return;
    let breakpoint = [...this.breakpointList].find((breakpoint) => window.matchMedia(convertBreakpoint(breakpoint)).matches);
    this.classList.toggle('has-navigation', !navigation.nextEl.closest('.swiper-navigation').classList.contains(`${breakpoint}-hide`));
  }
}

customElements.define('theme-swiper', ThemeSwiper);

class ThemeTab extends HTMLElement {
  constructor() {
    super();
  }

  get allItems() {
    return this._allItems = this._allItems || this.querySelectorAll('[data-filter]')
  }

  filtering(value) {
    if(value == 'all') {
      Array.from(this.allItems).forEach((item) => item.classList.remove('hidden'));
    } else {
      const items = this.querySelectorAll(`[data-filter=${value}]`);
      Array.from(this.allItems).forEach((item) => item.classList.add('hidden'));
      Array.from(items).forEach((item, index) => {
        item.classList.remove('hidden')
        if(index == 0) item.querySelector('button')?.click();
      });
    }
  }

  open(button, tab) {
    if (button) this.setActiveElement(button);
    const _target = button.closest('li');
    if (_target.classList.contains('active')) return;
    const _active = this.querySelector(`li.active`);
    const _activeTab = this.querySelector(`.tab__content-item.active`);
    const _targetTab = this.querySelector(`[data-tab-id="${tab}"]`);
    this.load(_targetTab);
    _active.classList.remove('active');
    _activeTab.classList.remove('active');
    _target.classList.add('active');
    _targetTab.classList.add('active');
    // window.scrollTo({ top: this.getBoundingClientRect().top + window.pageYOffset, behavior: 'smooth' });
  }

  load(tab) {
    if (!tab.getAttribute('loaded')) {
      const content = tab.querySelector('template').content.cloneNode(true);
      tab.appendChild(content);
      tab.setAttribute('loaded', true);
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('theme-tab', ThemeTab);

class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(this.detailsContainer.querySelector('[tabindex="-1"]'), this.detailsContainer.querySelector('input:not([type="hidden"])'));
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);

class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener('input', debounce((event) => this.onChange(event), ON_CHANGE_DEBOUNCE_TIMER).bind(this));
    }
  }

  toggleResetButton() {
    if(!this.resetButton) return;
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

class ShowMoreButton extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    button.addEventListener('click', this.expandShowMore.bind(this));
  }

  expandShowMore(event) {
    const button = event.currentTarget;
    const parent = button.closest('.parent-wrap');
    button.classList.toggle('show');
    button.querySelector('span').innerText = button.classList.contains('show') ? button.dataset.showLessText : button.dataset.showMoreText;
    parent.querySelectorAll('.show-more-item').forEach(item => item.classList.toggle('hidden'))
  }
}

customElements.define('show-more-button', ShowMoreButton);

class StickyNavigation extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.anchor = document.querySelector(this.dataset.anchor);
    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, false);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  onScroll() {
    this.classList.remove('hidden');
    if (this.anchor && this.check(this.anchor, 0)) {
      requestAnimationFrame(this.show.bind(this));
    } else {
      requestAnimationFrame(this.hide.bind(this));
    }
  }

  check(element, threshold) {
    let rect = element.getBoundingClientRect().bottom;
    threshold = threshold ? threshold : 0;
    return rect + threshold > 0
  }

  hide() {
    this.classList.remove('animate', 'active');
    document.body.classList.remove('navigation-sticky__show');
    document.body.style.setProperty('--navigation-sticky-height', 0);
  }

  show() {
    this.classList.add('animate', 'active');
    document.body.classList.add('navigation-sticky__show');
    document.body.style.setProperty('--navigation-sticky-height', `${Math.floor(this.offsetHeight)}px`);
  }
}

customElements.define('sticky-navigation', StickyNavigation);

// PluralCart
document.addEventListener('pc-cart:added', function(evt) {
  this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  if (this.cart) this.cartItems = this.cart.querySelector(`${this.cart.nodeName.toLowerCase()}-items`);
  let count = evt.detail?.items?.reduce((acc, val) => {
    return acc + val.quantity;
  }, 0);
  count = window.cartCount + count;
  fetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-notification')
    .then(response => response.json())
    .then(response => {
      if (this.cartItems) {
        this.cartItems.renderContents({ sections: response }, count);
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pluralcart' });
      }
    });
});

if (Shopify.designMode) {
  document.addEventListener('shopify:block:select', () => {
    closeSideDrawer();
    hideModalDialog();
  });
  document.addEventListener('shopify:block:deselect', () => {
    closeSideDrawer();
    hideModalDialog();
  });
  document.addEventListener('shopify:section:load', () => {
    closeSideDrawer();
    hideModalDialog();
  });
  document.addEventListener('shopify:section:reorder', () => {
    closeSideDrawer();
    hideModalDialog();
  });
  document.addEventListener('shopify:section:select', () => {
    closeSideDrawer();
    hideModalDialog();
  });
  document.addEventListener('shopify:section:deselect', () => {
    closeSideDrawer();
    hideModalDialog();
  });
  document.addEventListener('shopify:inspector:activate', () => {
    closeSideDrawer();
    hideModalDialog();
  });
  document.addEventListener('shopify:inspector:deactivate', () => {
    closeSideDrawer();
    hideModalDialog();
  });
}